import { useMemo } from 'react';
import { getConversationList, useInfiniteConversationsQuery } from 'shared/legacy/hooks/useInfiniteConversationsQuery';
import { useInboxStore } from 'stores/inbox/inbox.store';
import { InboxConversationList } from '../InboxConversationList/InboxConversationList';

export const InboxConversationPreview = () => {
  const teamView = useInboxStore((s) => s.isTeamViewEnabled);
  const conversationScope = useInboxStore((s) => s.selectedFilter);

  const { data: conversations, isLoading } = useInfiniteConversationsQuery({
    teamView,
    conversationScope,
  });

  const conversationList = useMemo(() => getConversationList(conversations).slice(0, 5), [conversations]);

  return (
    <InboxConversationList
      showTeamView={false}
      showFilters={true}
      conversations={conversationList}
      isLoading={isLoading}
    />
  );
};
